<template>
  <!-- Toddy -->
  <div class="slcb-toddy__view-content">
    <!-- Header -->
    <div class="slcb-toddy__header-container">
      <div class="slcb-toddy__header" v-bind:class="[isClosing ? 'slcb-toddy__header--closing' : 'slcb-toddy__header--starting']" v-if="!isDone">
        <b-container style="height: 100%">
          <b-row style="height: 100%">
            <b-col cols="12" class="slcb-toddy__header-title-container">
              <div class="slcb-toddy__header-title-child-container">
                <h1 class="slcb-toddy__header-title" v-bind:class="[isClosing ? 'slcb-toddy__header-title--closing' : 'slcb-toddy__header-title--starting']">Registre a sua marca</h1>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="slcb-toddy__header slcb-toddy__header--initiate" v-bind:class="[!isDone ? 'slcb-toddy__header--initiate-fixed' : '']">
        <b-container>
          <b-row class="slcb-toddy__header-nav-title-container slcb-toddy__header-title-container--done">
            <b-col cols="12" class="slcb-toddy__header-nav-title-innercontainer">
              <div class="slcb-toddy__header-nav" v-if="stepBack && previousNodo != undefined">
                <button type="button" class="slcb-toddy__header-nav-item" v-on:click="previousStep">
                  <b-img src="~@/assets/img/arrow_left.svg" alt="Flecha para esquerda"/>
                </button>
              </div>
              <span class="slcb-toddy__header-nav-title slcb-toddy__header-nav-title--done" v-bind:class="[(stepBack && previousNodo != undefined) ? 'slcb-toddy__header-nav-title--sub-left' : '']">Registre a sua marca</span>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- Messages -->
    <div id="terminal-chat" class="slcb-toddy__terminal-chat-container" v-bind:style="{minHeight: 'calc(100% - '+ boxInputHeight +'px)', maxHeight: 'calc(100% - '+ boxInputHeight +'px)'}" v-if="isDone">
      <b-container>
        <b-row class="slcb-toddy__terminal-chat-row">
          <b-col id="terminal-chat-col" cols="12" md="10" offset-md="1">

            <!-- Inicio -->
            <div class="slcb-toddy__dialog" v-if="chatbot.inicio.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Olá, seja bem-vindo(a)! Meu nome é Toddy!<br/>O que você deseja fazer?']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <div class="slcb-toddy__dialog slcb-toddy__dialog--reply-box clearfix" v-if="chatbot.inicio.resposta" v-autobottom>
              <div class="slcb-toddy__dialog-icon-text float-right">
                <span class="slcb-toddy__dialog-icon slcb-toddy__dialog-icon--text align-top">{{ letterIcon }}</span>
              </div>
              <div class="slcb-toddy__dialog-text slcb-toddy__dialog-text--reply typed-element">
                <p>{{ chatbot.inicio.resposta }}</p>
              </div>
            </div>

            <!-- Protocolo - Step 1 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.protocolo.step1.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Ok, precisarei do ID de chamada para verificar se já está pronto o seu protocolo.']" :typeSpeed="25" :showCursor="false" :contentType="'html'"  @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Protocolo - Step 2 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.protocolo.step2.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Ótimo o seu protocolo já está pronto.']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Protocolo - Step 3 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.protocolo.step3.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['O seu protocolo ainda não está pronto, verifique mais tarde.']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Nome -->
            <div id="nomeRegistro" class="slcb-toddy__dialog" v-if="chatbot.nome.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Muito bem. Antes de começarmos com o registro, me diga: qual é o seu nome?']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <div class="slcb-toddy__dialog slcb-toddy__dialog--reply-box clearfix" v-if="chatbot.nome.resposta" v-autobottom>
              <div class="slcb-toddy__dialog-icon-text float-right">
                <span class="slcb-toddy__dialog-icon slcb-toddy__dialog-icon--text align-top">{{ letterIcon }}</span>
              </div>
              <div class="slcb-toddy__dialog-text slcb-toddy__dialog-text--reply float-right">
                <p>Meu nome é {{ form.nome }}</p>
              </div>
            </div>

            <!-- Processo -->
            <div class="slcb-toddy__dialog" v-if="chatbot.processo.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Muito prazer, <strong>' + form.nome + '!</strong><br/>Vamos lá! Você sabe como funciona um processo de registro de marca?']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <div class="slcb-toddy__dialog slcb-toddy__dialog--reply-box clearfix" v-if="chatbot.processo.resposta" v-autobottom>
              <div class="slcb-toddy__dialog-icon-text float-right">
                <span class="slcb-toddy__dialog-icon slcb-toddy__dialog-icon--text align-top">{{ letterIcon }}</span>
              </div>
              <div class="slcb-toddy__dialog-text slcb-toddy__dialog-text--reply typed-element">
                <p>{{ chatbot.processo.resposta }}</p>
              </div>
            </div>

            <!-- Texto Explicativo - Step 1 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.textoExplicativo.step1.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['<strong>Passo 1</strong> - Busca de anterioridade/Pesquisa Prévia:<br/><br>Primeiramente é necessário realizar a &#34;busca de anterioridade&#34;/&#34;pesquisa prévia&#34; antes de efetuar o pedido de registro de marcas, para verificar se já existe marca anteriormente depositada/registrada, que possa constituir impedimento legal à concessão do registro. É com base nestas informações que concluímos sobre a viabilidade de registro da marca.']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="nextStep(chatbot.processo, chatbot.textoExplicativo.step1, chatbot.textoExplicativo.step2)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Texto Explicativo - Step 2 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.textoExplicativo.step2.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['<strong>Passo 2</strong> – Protocolo do pedido de Registro:<br/><br/>O pedido de registro de marca é requerido através de protocolo de um formulário próprio do INPI, onde são prestadas informações e fornecidos dados sobre a marca e o requerente, além do pagamento da retribuição ao INPI.']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="nextStep(chatbot.processo, chatbot.textoExplicativo.step2, chatbot.textoExplicativo.step3)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Texto Explicativo - Step 3 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.textoExplicativo.step3.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['<strong>Passo 3</strong> - Exame do pedido<br/><br/>Protocolado, em aproximadamente 60 dias, o pedido de registro é publicado na Revista de Propriedade Industrial, abrindo prazo de 60 dias para que terceiros possam apresentar oposição ao registro. Se houver oposição ao pedido de registro, será necessário analisar os argumentos e é aconselhável apresentar uma manifestação.']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="nextStep(chatbot.processo, chatbot.textoExplicativo.step3, chatbot.textoExplicativo.step4)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Texto Explicativo - Step 4 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.textoExplicativo.step4.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['<strong>Passo 4</strong> - Julgamento do pedido<br/><br/>Concluído o exame, será proferida decisão, deferindo ou indeferindo o pedido de registro.<br/><br/>Havendo o DEFERIMENTO DO PEDIDO DE REGISTRO será necessário fazer o pagamento de taxa decenal, para que o registro da marca tenha vigência pelo prazo de 10 anos.<br/><br/>Caso ocorra INDEFERIMENTO DO PEDIDO DE REGISTRO deve ser apresentado recurso contra o indeferimento, apresentando argumentos e provas que sejam capazes de constituírem direito ao registro da marca.']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Marca -->
            <div class="slcb-toddy__dialog" v-if="chatbot.marca.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Ótimo! Agora, vamos colocar a mão na massa! Qual é o nome da sua marca?']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <div class="slcb-toddy__dialog slcb-toddy__dialog--reply-box clearfix" v-if="chatbot.marca.resposta" v-autobottom>
              <div class="slcb-toddy__dialog-icon-text float-right">
                <span class="slcb-toddy__dialog-icon slcb-toddy__dialog-icon--text align-top">{{ letterIcon }}</span>
              </div>
              <div class="slcb-toddy__dialog-text slcb-toddy__dialog-text--reply typed-element">
                <p>O nome da minha marca é {{ form.marca }}</p>
              </div>
            </div>

            <!-- Logo -->
            <div class="slcb-toddy__dialog" v-if="chatbot.logo.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Que nome bacana! Agora, vou precisar que você me envie uma imagem da sua marca.<br/><br/>(Importante: a marca deve ser um arquivo em formato <strong>JPEG</strong>, no tamanho <strong>8x8cm</strong>).']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <div class="slcb-toddy__dialog slcb-toddy__dialog--reply-box clearfix" v-if="chatbot.logo.resposta" v-autobottom>
              <div class="slcb-toddy__dialog-icon-text float-right">
                <span class="slcb-toddy__dialog-icon slcb-toddy__dialog-icon--text align-top">{{ letterIcon }}</span>
              </div>
              <div class="slcb-toddy__dialog-text slcb-toddy__dialog-text--reply typed-element" v-for="(item, index) in chatbot.logo.uploadedFiles" :key="index">
                <img :src="item.url" :alt="item.originalName">
              </div>
            </div>

            <!-- Função -->
            <div class="slcb-toddy__dialog" v-if="chatbot.funcao.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['A Marca <strong>' + form.marca + '</strong> que você quer registrar é para estampar um produto (ex. celular, relógio, etc...) ou para identificar um serviço (ex. sites, aplicativos, consultorias, etc..)?']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <div class="slcb-toddy__dialog slcb-toddy__dialog--reply-box clearfix" v-if="chatbot.funcao.resposta" v-autobottom>
              <div class="slcb-toddy__dialog-icon-text float-right">
                <span class="slcb-toddy__dialog-icon slcb-toddy__dialog-icon--text align-top">{{ letterIcon }}</span>
              </div>
              <div class="slcb-toddy__dialog-text slcb-toddy__dialog-text--reply typed-element">
                <p>{{ chatbot.funcao.resposta }}</p>
              </div>
            </div>

            <!-- Classes -->
            <div class="slcb-toddy__dialog" v-if="chatbot.classes.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Muito bem! Agora você precisa escolher a(s) classe(s) em que o seu produto se enquadra:']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showFields(chatbot.classes)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Lista de Classes -->
            <div class="slcb-toddy__class-box-master-container" v-if="chatbot.classes.fields" v-autobottom>

              <!-- Lista de Classes - Produto -->
              <div class="slcb-toddy__class-box" v-if="chatbot.classes.fields && form.tipo_de_empresa == 'Produto'" v-for="(item, index) in chatbot.classes.produto" :key="index">
                <label v-bind:for="item.classe" class="slcb-toddy__class-box-label">{{ item.titulo }}
                  <input type="checkbox" v-bind:name="item.classe" v-bind:id="item.classe" class="slcb-toddy__class-box-checkbox" :value="item.classe" v-model="form.classes">
                  <span class="slcb-toddy__class-box-text" v-bind:class="[item.collapsed ? 'slcb-toddy__class-box-text--collapsed' : '']">
                    {{ item.descricao }}
                  </span>
                </label>
                <b-button variant="none" class="slcb-toddy__class-box-see-more" v-on:click="seeMore(item)">Ver mais</b-button>
              </div>

              <!-- Lista de Classes - Serviço -->
              <div class="slcb-toddy__class-box" v-if="chatbot.classes.fields && form.tipo_de_empresa == 'Serviço'" v-for="(item, index) in chatbot.classes.servico" :key="index">
                <label v-bind:for="item.classe" class="slcb-toddy__class-box-label">{{ item.titulo }}
                  <input type="checkbox" v-bind:name="item.classe" v-bind:id="item.classe" class="slcb-toddy__class-box-checkbox" :value="item.classe" v-model="form.classes">
                  <span class="slcb-toddy__class-box-text" v-bind:class="[item.collapsed ? 'slcb-toddy__class-box-text--collapsed' : '']">
                    {{ item.descricao }}
                  </span>
                </label>
                <b-button variant="none" class="slcb-toddy__class-box-see-more" v-on:click="seeMore(item)">Ver mais</b-button>
              </div>

            </div>

            <!-- Registro - Step 1 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.registro.step1.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Legal! Agora que entendi melhor o que a sua marca faz!<br/><br/>Agora preciso saber: a marca será registrada em nome de uma pessoa física ou de uma pessoa jurídica?']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <div class="slcb-toddy__dialog slcb-toddy__dialog--reply-box clearfix" v-if="chatbot.registro.step1.resposta" v-autobottom>
              <div class="slcb-toddy__dialog-icon-text float-right">
                <span class="slcb-toddy__dialog-icon slcb-toddy__dialog-icon--text align-top">{{ letterIcon }}</span>
              </div>
              <div class="slcb-toddy__dialog-text slcb-toddy__dialog-text--reply typed-element">
                <p>{{ chatbot.registro.step1.resposta }}</p>
              </div>
            </div>

            <!-- Registro - Step 2 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.registro.step2.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['A Pessoa Jurídica é uma Micro Empresa ou Empresa de Pequeno Porte?']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <div class="slcb-toddy__dialog slcb-toddy__dialog--reply-box clearfix" v-if="chatbot.registro.step2.resposta" v-autobottom>
              <div class="slcb-toddy__dialog-icon-text float-right">
                <span class="slcb-toddy__dialog-icon slcb-toddy__dialog-icon--text align-top">{{ letterIcon }}</span>
              </div>
              <div class="slcb-toddy__dialog-text slcb-toddy__dialog-text--reply typed-element">
                <p>{{ chatbot.registro.step2.resposta }}, é uma Micro Empresa ou Empresa de Pequeno Porte.</p>
              </div>
            </div>

            <!-- Registro - Step 3 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.registro.step3.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Será uma ' + (form.pessoa_fisica ? 'Pessoa Física' : 'Pessoa Júridica') + ' a proprietária da marca!<br/><br/>Para completar o cadastro, eu vou precisar de algumas informações:']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showFields(chatbot.registro.step3)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <b-form ref="registroStep3" v-if="chatbot.registro.step3.fields">
              <b-row>
                <b-col cols="12" md="8" offset-md="2">
                  <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                    <b-form-input id="registro_nome_completo" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.nome_completo" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.nome_completo }" autocomplete="off" required>
                    </b-form-input>
                    <label for="registro_nome_completo" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">{{ form.pessoa_fisica ? 'Nome Completo' : 'Razão Social' }}</label>
                  </div>
                </b-col>
                <b-col cols="12" md="8" offset-md="2" v-if="form.pessoa_fisica">
                  <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                    <b-form-input id="registro_cpf" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.cpf" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.cpf }" pattern="\d{3}\.\d{3}\.\d{3}-\d{2}" v-mask="'###.###.###-##'" autocomplete="off" required>
                    </b-form-input>
                    <label for="registro_cpf" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">CPF</label>
                  </div>
                </b-col>
                <b-col cols="12" md="8" offset-md="2" v-if="!form.pessoa_fisica">
                  <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                    <b-form-input id="registro_cnpj" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.cnpj" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.cnpj }" v-mask="'##.###.###/####-##'" pattern="\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}" autocomplete="off" required>
                    </b-form-input>
                    <label for="registro_cnpj" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">CNPJ</label>
                  </div>
                </b-col>
                <b-col cols="12" md="4" offset-md="2">
                  <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                    <b-form-input type="email" id="registro_email" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.email" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.email }" autocomplete="off" required>
                    </b-form-input>
                    <label for="registro_email" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">Email</label>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                    <b-form-input type="tel" id="registro_telefone" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.telefone" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.telefone }" pattern="\([0-9]{2}\) [0-9]{4,5}-[0-9]{4}$" v-mask="['(##) ####-####', '(##) #####-####']" autocomplete="off" required>
                    </b-form-input>
                    <label for="registro_telefone" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">Telefone</label>
                  </div>
                </b-col>
              </b-row>
            </b-form>

            <!-- Registro - Step 4 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.registro.step4.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Também será necesário informações do endereço para prosseguir o processo de registro:']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showFields(chatbot.registro.step4)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <b-form ref="registroStep4" v-if="chatbot.registro.step4.fields">
              <b-row>
                <b-col cols="12" md="8" offset-md="2">
                  <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                    <b-form-input id="registro_cep" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.cep" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.cep }" pattern="\d{5}-\d{3}" v-mask="'#####-###'" autocomplete="off" required>
                    </b-form-input>
                    <label for="registro_cep" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">CEP</label>
                  </div>
                </b-col>
                <b-col cols="12" md="8" offset-md="2">
                  <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                    <b-form-input id="registro_endereco" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.endereco" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.endereco }" autocomplete="off" required>
                    </b-form-input>
                    <label for="registro_endereco" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">Endereço</label>
                  </div>
                </b-col>
                <b-col cols="12" md="4" offset-md="2">
                  <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                    <b-form-input id="registro_numero" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.numero" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.numero }" autocomplete="off" required>
                    </b-form-input>
                    <label for="registro_numero" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">Número</label>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                    <b-form-input id="registro_complemento" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.complemento" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.complemento }" autocomplete="off">
                    </b-form-input>
                    <label for="registro_complemento" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">Complemento</label>
                  </div>
                </b-col>
                <b-col cols="12" md="8" offset-md="2">
                  <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                    <b-form-input id="registro_bairro" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.bairro" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.bairro }" autocomplete="off" required>
                    </b-form-input>
                    <label for="registro_bairro" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">Bairro</label>
                  </div>
                </b-col>
                <b-col cols="12" md="4" offset-md="2">
                  <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                    <b-form-input id="registro_cidade" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.cidade" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.cidade }" autocomplete="off" required>
                    </b-form-input>
                    <label for="registro_cidade" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">Cidade</label>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                    <b-form-select id="registro_estado" v-model="form.estado" :options="chatbot.registro.step4.uf" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.estado }" autocomplete="off" required/>
                    <label for="registro_estado" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">Estado</label>
                  </div>
                </b-col>
              </b-row>
            </b-form>

            <!-- Procedimento - Step1 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.procedimento.step1.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Já temos tudo para iniciarmos o seu processo de registro de marca.<br/><br/>A marca <strong>' + form.marca + '</strong> com a função <strong>' + form.tipo_de_empresa + '</strong> e irá ser registrada nas seguintes classes:']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showFields(chatbot.procedimento.step1);showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <b-row v-if="chatbot.procedimento.step1.fields" style="margin-bottom: 1rem;">
              <b-col cols="12" md="4" v-for="(item, index) in form.classes" :key="index">
                <div class="slcb-toddy__mini-box">
                  <span class="slcb-toddy__mini-box-title">{{ item }}</span>
                </div>
              </b-col>
            </b-row>

            <!-- Procedimento - Step2 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.procedimento.step2.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Agora com estas informações vou conversar com meus colegas advogados e iremos realizar a pesquisa para ver se sua marca pode ser registrada tranquilamente.']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="nextStep(chatbot.procedimento.step2, chatbot.procedimento.step2, chatbot.procedimento.step3)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Procedimento - Step3 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.procedimento.step3.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['O valor de nossos serviços para o registro da marca ficará no total de ' + form.total + '<br/><br/>Sendo composto da seguinte forma:']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showFields(chatbot.procedimento.step3);showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <b-row v-if="chatbot.procedimento.step3.fields" style="margin-bottom: 1rem;">
              <b-col cols="12" md="4">
                <div class="slcb-toddy__mini-box">
                  <span class="slcb-toddy__mini-box-title">Taxa de pesquisa</span>
                  <span>{{ form.txPesquisa }}</span>
                </div>
              </b-col>
              <b-col cols="12" md="4">
                <div class="slcb-toddy__mini-box">
                  <span class="slcb-toddy__mini-box-title">Taxas INPI</span>
                  <span>{{ form.txINPI }}</span>
                </div>
              </b-col>
              <b-col cols="12" md="4">
                <div class="slcb-toddy__mini-box">
                  <span class="slcb-toddy__mini-box-title">Serviços</span>
                  <span>{{ form.txServicos }}</span>
                </div>
              </b-col>
            </b-row>

            <!-- Termos de uso -->
            <div class="slcb-toddy__dialog" v-if="chatbot.termosDeUso.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Caso concluirmos que a marca não possa ser registrada, iremos lhe restituir os valores da Taxa do INPI e dos Serviços, sendo somente cobrado por nós a Taxa de Pesquisa, OK? Importante você também <a href=\'./static/files/termos_de_uso.pdf\' target=\'_BLANK\'>ler e concordar com nossos termos de uso e serviços.</a>']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <div class="slcb-toddy__dialog slcb-toddy__dialog--reply-box clearfix" v-if="chatbot.termosDeUso.resposta" v-autobottom>
              <div class="slcb-toddy__dialog-icon-text float-right">
                <span class="slcb-toddy__dialog-icon slcb-toddy__dialog-icon--text align-top">{{ letterIcon }}</span>
              </div>
              <div class="slcb-toddy__dialog-text slcb-toddy__dialog-text--reply typed-element">
                <p>Li e concordo com os termos de uso.</p>
              </div>
            </div>

            <!-- Cobrança - Cartão de Crédito -->
            <div class="slcb-toddy__dialog" v-if="false">
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Perfeito. Agora vamos precisar de seus dados de cobrança:']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showFields(chatbot.cobranca)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <b-row v-if="chatbot.cobranca.fields">
              <b-col cols="12" md="8" offset-md="2">
                <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                  <b-form-input id="registro_nome_cartao" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.cartao_titular" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.cartao_titular }">
                  </b-form-input>
                  <label for="registro_nome_cartao" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">Nome do títular do cartão</label>
                </div>
              </b-col>
              <b-col cols="12" md="8" offset-md="2">
                <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                  <b-form-input id="registro_numero_cartao" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.cartao_numero" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.cartao_numero }">
                  </b-form-input>
                  <label for="registro_numero_cartao" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">Número do cartão</label>
                </div>
              </b-col>
              <b-col cols="12" md="4" offset-md="2">
                <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                  <b-form-input id="registro_validade_cartao" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.cartao_validade" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.cartao_validade }">
                  </b-form-input>
                  <label for="registro_validade_cartao" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">Data de validade do cartão</label>
                </div>
              </b-col>
              <b-col cols="12" md="4">
                <div class="form-group slcb-toddy__dialog-form-group slcb-toddy__dialog-form-group--opacity">
                  <b-form-input id="registro_cvv_cartao" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--opacity" v-model="form.cartao_cvv" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.cartao_cvv }">
                  </b-form-input>
                  <label for="registro_cvv_cartao" class="slcb-toddy__dialog-label slcb-toddy__dialog-label--opacity">CVV</label>
                </div>
              </b-col>
            </b-row>

            <!-- Cobrança -->
            <div class="slcb-toddy__dialog" v-if="chatbot.cobranca.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Perfeito. Agora pode escolher a melhor forma de pagamento para você:']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>
            <div class="slcb-toddy__dialog slcb-toddy__dialog--reply-box clearfix" v-if="chatbot.cobranca.resposta" v-autobottom>
              <div class="slcb-toddy__dialog-icon-text float-right">
                <span class="slcb-toddy__dialog-icon slcb-toddy__dialog-icon--text align-top">{{ letterIcon }}</span>
              </div>
              <div class="slcb-toddy__dialog-text slcb-toddy__dialog-text--reply typed-element">
                <p>{{ chatbot.cobranca.resposta }}</p>
              </div>
            </div>

            <!-- Boleto -->
            <div class="slcb-toddy__dialog" v-if="chatbot.boleto.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['OK, em até 2 dias úteis você receberá por e-mail o boleto para pagamento.']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="nextStep(chatbot.cobranca, chatbot.cobranca, chatbot.procuracao)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Depósito -->
            <div class="slcb-toddy__dialog" v-if="chatbot.deposito.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Para pagamento via depósito bancário nossos dados são esses: <strong>Banco do Brasil (001)</strong>, Agência: <strong>3876-8</strong>, Conta Corrente: <strong>123306-8</strong>, Titular: <strong>LAYON LOPES DA SILVA SOCIEDADE INDIVIDUAL DE ADVOCACIA</strong>, CNPJ: <strong>24.750.801/0001-32</strong>']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Pagamento Realizado -->
            <div class="slcb-toddy__dialog" v-if="false">
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['O seu pagamento foi realizado com sucesso! Agora vamos iniciar o seu processo no INPI!']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Procuração -->
            <div class="slcb-toddy__dialog" v-if="chatbot.procuracao.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Precisamos que você assine e envie esta procuração.<br/><br/>Pode enviar para o e-mail (contato@silvalopes.adv.br).<br/><br/>Após nos enviar a procuração, em questão de 05 (cinco) dias você receberá de nós o comprovante de protocolo do seu pedido de registro de marca.']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Erro de salvamento de registro -->
            <div class="slcb-toddy__dialog" v-if="chatbot.error.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Ocorreu um erro ao salvar o seu pedido de registro de marca!']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Fim - Step 1 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.fim.step1.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['O seu ID de chamada é <strong>' + id_chamada + '</strong>.<br/><br/>Basta voltar aqui e informar seu ID de chamada para acompanhar se seu processo já foi protocolado no INPI.']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="nextStep(chatbot.fim.step1, chatbot.fim.step1, chatbot.fim.step2)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

            <!-- Fim - Step 2 -->
            <div class="slcb-toddy__dialog" v-if="chatbot.fim.step2.toddy" v-autobottom>
              <figure class="slcb-toddy__dialog-icon float-left">
                <b-img src="~@/assets/img/toddy.png" alt="Ícone do Toddy" class="img-fluid" />
              </figure>
              <vue-typed-js :strings="['Até a próxima, tchau!']" :typeSpeed="25" :showCursor="false" :contentType="'html'" @onComplete="showBoxInput(true)">
                <p class="typing slcb-toddy__dialog-text"></p>
              </vue-typed-js>
            </div>

          </b-col>
        </b-row>
      </b-container>
    </div>
    <!-- Inputs -->
    <div id="terminal-input" class="slcb-toddy__terminal-input-bg-container" v-if="isDone && boxInput">
      <b-container class="slcb-toddy__terminal-input-container">

        <!-- Inicio -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.inicio.input">
          <b-col cols="12" md="6" lg="4" offset-lg="2">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="inicio($event, true)">Iniciar um registro de marca</b-button>
          </b-col>
          <b-col cols="12" md="6" lg="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="inicio($event, false)">Verificar se já foi protocolado</b-button>
          </b-col>
        </b-row>

        <!-- Protocolo - Step 1 -->
        <b-row v-if="chatbot.protocolo.step1.input">
          <b-col cols="12" md="8" offset-md="2">
            <b-form @submit="protocolo">
              <div class="form-group slcb-toddy__dialog-form-group">
                <b-form-input id="id_chamada" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--arrow" v-model="id_chamada" v-bind:class="{ 'slcb-toddy__dialog-input--filled': id_chamada }" autocomplete="off" v-focus required>
                </b-form-input>
                <b-btn type="submit" variant="none" class="slcb-toddy__dialog-button-input">
                  <img src="~@/assets/img/arrow_right.svg" alt="Continuar" />
                </b-btn>
                <label for="id_chamada" class="slcb-toddy__dialog-label">Digite a ID da chamada</label>
              </div>
              <b-alert show variant="danger" class="slcb-toddy__dialog-error" v-if="chatbot.protocolo.step1.error">ID de chamada inválido</b-alert>
            </b-form>
          </b-col>
        </b-row>

        <!-- Protocolo - Step 2 -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.protocolo.step2.input">
          <b-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4">
            <b-link :href="arquivo_protocolo" target="_blank" class="btn slcb-toddy__dialog-button" v-on:click="protocoloStep2()" download>Fazer download do protocolo</b-link>
          </b-col>
        </b-row>

        <!-- Protocolo - Step 3 -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.protocolo.step3.input">
          <b-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4">
            <b-link href="http://silvalopes.adv.br/" target="_blank" class="btn slcb-toddy__dialog-button" v-focus>Ir para o site da Silva Lopes Advogados</b-link>
          </b-col>
        </b-row>

        <!-- Nome -->
        <b-row v-if="chatbot.nome.input">
          <b-col cols="12" md="8" offset-md="2">
            <b-form @submit="nome">
              <div class="form-group slcb-toddy__dialog-form-group">
                <b-form-input id="registro_nome" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--arrow" v-model="form.nome" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.nome }" autocomplete="off" v-focus required>
                </b-form-input>
                <b-btn type="submit" variant="none" class="slcb-toddy__dialog-button-input">
                  <img src="~@/assets/img/arrow_right.svg" alt="Continuar" />
                </b-btn>
                <label for="registro_nome" class="slcb-toddy__dialog-label">Digite o seu nome</label>
              </div>
            </b-form>
          </b-col>
        </b-row>

        <!-- Processo -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.processo.input">
          <b-col cols="12" md="6" lg="4" offset-lg="2">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="processo($event, true)">Sim, eu já sei tudo sobre o processo de registro</b-button>
          </b-col>
          <b-col cols="12" md="6" lg="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="processo($event, false)">Não sei muito. Me explica melhor</b-button>
          </b-col>
        </b-row>

        <!-- Texto Explicativo -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.textoExplicativo.step4.input">
          <b-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="nextStep(chatbot.processo,chatbot.textoExplicativo.step4,chatbot.marca)" v-focus>Avançar</b-button>
          </b-col>
        </b-row>

        <!-- Marca -->
        <b-row v-if="chatbot.marca.input">
          <b-col cols="12" md="8" offset-md="2">
            <b-form @submit="marca">
              <div class="form-group slcb-toddy__dialog-form-group">
                <b-form-input id="registro_marca" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--arrow" v-model="form.marca" v-bind:class="{ 'slcb-toddy__dialog-input--filled': form.marca }" autocomplete="off" v-focus required>
                </b-form-input>
                <b-btn type="submit" variant="none" class="slcb-toddy__dialog-button-input">
                  <img src="~@/assets/img/arrow_right.svg" alt="Continuar" />
                </b-btn>
                <label for="registro_marca" class="slcb-toddy__dialog-label">Digite o nome da sua marca</label>
              </div>
            </b-form>
          </b-col>
        </b-row>

        <!-- Logo -->
        <b-row v-if="chatbot.logo.input && isInitial">
          <b-col cols="12">
            <div class="slcb-toddy__dropbox  slcb-toddy__dropbox--waiting">
              <input type="file" :name="chatbot.logo.uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/jpg, image/jpeg" class="slcb-toddy__input-file">
              <p class="slcb-toddy__dropbox-text">Arraste o arquivo aqui e o solte para fazer upload.</p>
              <b-button variant="none" class="slcb-toddy__dialog-button">Ou procure o arquivo e faça o upload</b-button>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="chatbot.logo.input && isSaving">
          <b-col cols="12" md="8" offset-md="2">
            <div class="slcb-toddy__dropbox slcb-toddy__dropbox--uploading">
              <p class="slcb-toddy__dropbox-text">Sua imagem está sendo carregada.</p>
              <b-progress ref="progress" :max="100" :value="chatbot.logo.uploadPercentage" show-progress></b-progress>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="chatbot.logo.input && isSuccess">
          <b-col cols="12" md="8" offset-md="2">
            <div class="slcb-toddy__preview-image">
              <div v-for="(item, index) in chatbot.logo.uploadedFiles" :key="index">
                <figure class="slcb-toddy__preview-image-figure">
                  <div class="slcb-toddy__preview-image-innercontainer">
                    <img :src="item.url" class="img-responsive img-thumbnail" :alt="item.originalName">
                    <b-button variant="none" class="slcb-toddy__cancel-button" v-on:click="resetUpload"><i class="fa fa-times" aria-hidden="true"></i></b-button>
                  </div>
                  <caption>{{ item.originalName }} - {{ item.width }} x {{ item.height }} - {{ item.size | Filesize }}</caption>
                </figure>
              </div>
              <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="logo">Continuar</b-button>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="chatbot.logo.input && isFailed">
          <b-col cols="12" md="8" offset-md="2">
            <div class="slcb-toddy__dropbox slcb-toddy__dropbox--uploading">
              <p class="slcb-toddy__dropbox-text">{{ chatbot.logo.uploadError }}</p>
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
              <b-button variant="none" class="slcb-toddy__dialog-button" style="margin-top: 5px;" v-on:click="resetUpload">Tentar novamente</b-button>
            </div>
          </b-col>
        </b-row>

        <!-- Função -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.funcao.input">
          <b-col cols="12" md="6" lg="4" offset-lg="2">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="funcao($event)">Produto</b-button>
          </b-col>
          <b-col cols="12" md="6" lg="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="funcao($event)">Serviço</b-button>
          </b-col>
        </b-row>

        <!-- Classes -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.classes.input">
          <b-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="classes($event, true)" :disabled="form.classes.length <= 0" v-focus>Avançar</b-button>
          </b-col>
        </b-row>

        <!-- Registro - step 1 -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.registro.step1.input">
          <b-col cols="12" md="6" lg="4" offset-lg="2">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="registroStep1(true)">Pessoa Física</b-button>
          </b-col>
          <b-col cols="12" md="6" lg="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="registroStep1(false)">Pessoa Jurídica</b-button>
          </b-col>
        </b-row>

        <!-- Registro - step 2 -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.registro.step2.input">
          <b-col cols="12" md="6" lg="4" offset-lg="2">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="registroStep2(true)">Sim</b-button>
          </b-col>
          <b-col cols="12" md="6" lg="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="registroStep2(false)">Não</b-button>
          </b-col>
        </b-row>

        <!-- Registro - step 3 -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.registro.step3.input">
          <b-col cols="12" md="4" offset-md="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="submitRegistroStep3($event)" v-focus>Avançar</b-button>
          </b-col>
        </b-row>

        <!-- Registro - step 4 -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.registro.step4.input">
          <b-col cols="12" md="4" offset-md="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="submitRegistroStep4($event)" v-focus>Avançar</b-button>
          </b-col>
        </b-row>

        <!-- Procedimento - step 1 -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.procedimento.step1.input">
          <b-col cols="12" md="4" offset-md="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="procedimentoStep1($event, true)" v-focus>Avançar</b-button>
          </b-col>
        </b-row>

        <!-- Procedimento - step 3 -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.procedimento.step3.input">
          <b-col cols="12" md="4" offset-md="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="procedimentoStep3($event, true)" v-focus>Avançar</b-button>
          </b-col>
        </b-row>

        <!-- Termos de Uso -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.termosDeUso.input">
          <b-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4">
            <b-button variant="none" class="btn slcb-toddy__dialog-button" v-on:click="termosDeUso($event, true)" v-focus>Li e concordo</b-button>
          </b-col>
        </b-row>

        <!-- Cobrança - Cartão de Crédito -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="false">
          <b-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="cobranca($event, true)" @keydown.enter.prevent="cobranca($event, true)" v-focus>>Avançar</b-button>
          </b-col>
        </b-row>

        <!-- Cobrança -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.cobranca.input">
          <b-col cols="12" md="6" lg="4" offset-lg="2">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="cobranca($event, true)">Boleto Bancário</b-button>
          </b-col>
          <b-col cols="12" md="6" lg="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="cobranca($event, false)">Depósito Bancário</b-button>
          </b-col>
        </b-row>

        <!-- Depósito -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.deposito.input">
          <b-col cols="12" md="4" offset-md="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="deposito()" v-focus>Avançar</b-button>
          </b-col>
        </b-row>

        <!-- Procuração -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.procuracao.input">
          <b-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="procuracao()" v-focus>Fazer download da procuração</b-button>
          </b-col>
        </b-row>

        <!-- Erro de salvamento de registro -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.error.input">
          <b-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4">
            <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="procuracao()" v-focus>Tentar novamente</b-button>
          </b-col>
        </b-row>

        <!-- Fim -->
        <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-if="chatbot.fim.step2.input">
          <b-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4">
            <b-link href="http://silvalopes.adv.br/" target="_blank" class="btn slcb-toddy__dialog-button" v-focus>Ir para o site da Silva Lopes Advogados</b-link>
          </b-col>
        </b-row>

      </b-container>
    </div>
  </div>
</template>

<script>
import { VueTypedJs } from 'vue-typed-js'
import { mask } from 'vue-the-mask'
import * as axios from 'axios'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
pdfMake.vfs = pdfFonts.pdfMake.vfs

const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3
const BASE_URL = 'https://api.registrodemarca.silvalopes.adv.br/parse/v1/'

axios.defaults.headers = {
  'X-Parse-Application-Id': '6939e808daa0c434d3d0a68825a529ba',
  'X-Parse-REST-API-Key': '0e60ad33a2b549cab413f83b97713d6c',
  'Content-Type': 'application/json'
}

export default {
  name: 'Toddy',
  data () {
    return {
      height: null,
      stepBack: false,
      previousNodo: null,
      steps: [],
      isClosing: false,
      isDone: false,
      boxInput: false,
      boxInputShow: false,
      boxInputHeight: '64px',
      letterIcon: 'a',
      id_chamada: null,
      arquivo_protocolo: false,
      chatbot: {
        inicio: {
          id: 0,
          toddy: true,
          input: true,
          resposta: null
        },
        protocolo: {
          step1: {
            id: 1,
            toddy: false,
            input: false,
            resposta: null,
            error: false
          },
          step2: {
            id: 2,
            toddy: false,
            input: false,
            resposta: null
          },
          step3: {
            id: 3,
            toddy: false,
            input: false,
            resposta: null
          },
          step4: {
            id: 4,
            toddy: false,
            input: false,
            resposta: null
          }
        },
        nome: {
          id: 5,
          toddy: false,
          input: false,
          resposta: false
        },
        processo: {
          id: 6,
          toddy: false,
          input: false,
          resposta: null
        },
        textoExplicativo: {
          step1: {
            id: 7,
            toddy: false,
            input: false,
            resposta: null
          },
          step2: {
            id: 8,
            toddy: false,
            input: false,
            fields: false
          },
          step3: {
            id: 9,
            toddy: false,
            input: false,
            resposta: null
          },
          step4: {
            id: 10,
            toddy: false,
            input: false,
            resposta: null
          }
        },
        marca: {
          id: 11,
          toddy: false,
          input: false,
          resposta: null
        },
        logo: {
          id: 12,
          toddy: false,
          input: false,
          preview: false,
          resposta: null,
          uploadedFiles: [],
          uploadError: null,
          currentStatus: null,
          uploadPercentage: 0,
          uploadFieldName: 'photos'
        },
        funcao: {
          id: 13,
          toddy: false,
          input: false,
          resposta: null
        },
        classes: {
          id: 14,
          toddy: false,
          input: false,
          fields: false,
          resposta: null,
          produto: [
            {classe: 'Classe 1', titulo: 'Classe 1', descricao: 'Substâncias químicas destinadas à indústria, às ciências, à fotografia, assim como à agricultura, à horticultura e à silvicultura; Resinas artificiais não processadas, matérias plásticas não processadas; Adubo, fertilizantes; Composições extintoras de fogo e para sua prevenção; Preparações para temperar e soldar; Substâncias químicas destinadas a conservar alimentos; Substâncias para curtir peles de animais e couro; Substâncias adesivas destinadas à indústria; Massas e outras substâncias de preenchimento; Preparações biológicas destinadas à indústria e à ciência.', collapsed: false},
            {classe: 'Classe 2', titulo: 'Classe 2', descricao: 'Tintas, vernizes, lacas; Preservativos contra oxidação e contra deterioração da madeira; Matérias tintoriais; Corantes e pigmentos; Tintas para imprimir, marcar e gravar; Mordentes; Resinas naturais em estado bruto; Metais em folhas e em pó para uso em pintura, decoração, impressão e arte.', collapsed: false},
            {classe: 'Classe 3', titulo: 'Classe 3', descricao: 'Preparações cosméticas e de toalete não medicinais; Preparações para branquear e outras substâncias para uso em lavanderia; Produtos para limpar, polir e decapar, produtos abrasivos; Sabões, exceto de uso medicinal; Perfumaria, óleos essenciais, cosméticos, exceto de uso medicinal; Loções capilares, exceto de uso medicinal; Dentifrícios, exceto de uso medicinal.', collapsed: false},
            {classe: 'Classe 4', titulo: 'Classe 4', descricao: 'Graxas e óleos industriais; Lubrificantes; Produtos para absorver, molhar e ligar pó; Combustíveis (incluindo gasolina para motores) e materiais para iluminação; Velas e pavios para iluminação.', collapsed: false},
            {classe: 'Classe 5', titulo: 'Classe 5', descricao: 'Produtos farmacêuticos, medicinais e veterinários; Preparações higiênicas para uso medicinal; Alimentos e substâncias dietéticas adaptadas para uso medicinal ou veterinário, alimentos para bebês; Suplementos alimentares para humanos e animais; Emplastros, materiais para curativos; Material para obturações dentárias, cera dentária; Desinfetantes; Preparações para destruição de animais nocivos; Fungicidas, herbicidas.', collapsed: false},
            {classe: 'Classe 6', titulo: 'Classe 6', descricao: 'Metais comuns e suas ligas, minérios; Materiais de metal para construção e edificação; Construções transportáveis de metal; Cabos e fios não elétricos de metal comum; Pequenos artigos de ferragem; Contêineres de metal para armazenagem e transporte; Cofres.', collapsed: false},
            {classe: 'Classe 7', titulo: 'Classe 7', descricao: 'Máquinas e máquinas-ferramentas; Motores (exceto para veículos terrestres); Engates de máquinas e componentes de transmissão (exceto para veículos terrestres); Instrumentos agrícolas não manuais; Chocadeiras; Máquinas distribuidoras automáticas.', collapsed: false},
            {classe: 'Classe 8', titulo: 'Classe 8', descricao: 'Ferramentas e instrumentos manuais (propulsão muscular); Cutelaria; Armas portáteis, exceto de fogo; Lâminas de barbear.', collapsed: false},
            {classe: 'Classe 9', titulo: 'Classe 9', descricao: 'Aparelhos e instrumentos científicos, náuticos, geodésicos, fotográficos, cinematográficos, ópticos, de pesagem, de medição, de sinalização, de controle (inspeção), de salvamento e de ensino; Aparelhos e instrumentos para conduzir, interromper, transformar, acumular, regular ou controlar eletricidade; Aparelhos para registrar, transmitir ou reproduzir som ou imagens; Suporte de registro magnético, discos acústicos; CDs, DVDs e outras mídias digitais para registro; Mecanismos para aparelhos operados com moedas; Caixas registradoras, máquinas de calcular, equipamento de processamento de dados e computadores; Programas de computador; Aparelhos extintores de incêndio.', collapsed: false},
            {classe: 'Classe 10', titulo: 'Classe 10', descricao: 'Aparelhos e instrumentos cirúrgicos, médicos, odontológicos e veterinários; Membros, olhos e dentes artificiais; Artigos ortopédicos; Material de sutura; Dispositivos terapêuticos e de assistência adaptados para deficientes; Aparelhos de massagem; Aparelhos, dispositivos e artigos para amamentação; Aparelhos, dispositivos e artigos de uso sexual.', collapsed: false},
            {classe: 'Classe 11', titulo: 'Classe 11', descricao: 'Aparelhos para iluminação, aquecimento, produção de vapor, cozinhar, refrigeração, secagem, ventilação, fornecimento de água e para fins sanitários.', collapsed: false},
            {classe: 'Classe 12', titulo: 'Classe 12', descricao: 'Veículos; Aparelhos para locomoção por terra, ar ou água.', collapsed: false},
            {classe: 'Classe 13', titulo: 'Classe 13', descricao: 'Armas de fogo; Munições e projéteis; Explosivos; Fogos de artifício.', collapsed: false},
            {classe: 'Classe 14', titulo: 'Classe 14', descricao: 'Metais preciosos e suas ligas; joias, bijuteria, pedras preciosas e semipreciosas; relojoaria e instrumentos cronométricos.', collapsed: false},
            {classe: 'Classe 15', titulo: 'Classe 15', descricao: 'Instrumentos musicais.', collapsed: false},
            {classe: 'Classe 16', titulo: 'Classe 16', descricao: 'Papel e papelão; material impresso; artigos para encadernação; fotografias; artigos de papelaria e materiais para escritório, exceto móveis; adesivos para papelaria ou uso doméstico; materiais para artistas e para desenho; pincéis; materiais de instrução e ensino; folhas, filmes e bolsas plásticas para embrulhar e embalar; caracteres de imprensa, clichês.', collapsed: false},
            {classe: 'Classe 17', titulo: 'Classe 17', descricao: 'Borracha, guta-percha, goma, amianto, mica e substitutos para todos estes materiais não processados ou semiprocessados; plásticos e resinas extrudados para uso na indústria; materiais para calafetar, vedar e isolar; canos, tubos e mangueiras flexíveis, não metálicos.', collapsed: false},
            {classe: 'Classe 18', titulo: 'Classe 18', descricao: 'Couro e imitações de couro; peles e couros de animais; bagagens e bolsas; guarda-chuvas, e guarda-sóis, bengalas; chicotes, arreios e selaria;coleiras, guias e roupas para animais.', collapsed: false},
            {classe: 'Classe 19', titulo: 'Classe 19', descricao: 'Materiais de construção (não metálicos); canos rígidos não metálicos para construção; asfalto, piche e betume; construções transportáveis não metálicas; monumentos não metálicos.', collapsed: false},
            {classe: 'Classe 20', titulo: 'Classe 20', descricao: 'Móveis, espelhos, molduras; Recipientes não metálicos para armazenagem e transporte; osso, chifre, barbatana de baleia ou madrepérola não trabalhados ou semitrabalhados; conchas; espuma-do-mar; âmbar amarelo.', collapsed: false},
            {classe: 'Classe 21', titulo: 'Classe 21', descricao: 'Utensílios e recipientes para a casa ou cozinha; utensílios de mesa (exceto garfos, facas e colheres) e conjuntos de panelas; pentes e esponjas; escovas, exceto para pintura; materiais para fabricação de escovas; materiais de limpeza; vidro não trabalhado ou semitrabalhado, exceto para construção; artigos de vidro, porcelana e faiança.', collapsed: false},
            {classe: 'Classe 22', titulo: 'Classe 22', descricao: 'Cordas e fios; redes; tendas e oleados; toldos de materiais têxteis ou sintéticos; velas de embarcações; sacos para transporte e armazenagem de materiais a granel; matérias de enchimento, exceto papel, papelão, borrachas e plásticos; matérias têxteis fibrosas em bruto e seus substitutos.', collapsed: false},
            {classe: 'Classe 23', titulo: 'Classe 23', descricao: 'Fios para uso têxtil.', collapsed: false},
            {classe: 'Classe 24', titulo: 'Classe 24', descricao: 'Tecidos e substitutos de tecidos; roupas de cama, mesa e banho; cortinas têxteis ou de plástico.', collapsed: false},
            {classe: 'Classe 25', titulo: 'Classe 25', descricao: 'Vestuário, calçados e chapelaria.', collapsed: false},
            {classe: 'Classe 26', titulo: 'Classe 26', descricao: 'Rendas e bordados, fitas e tranças; botões, colchetes e ilhoses, alfinetes e agulhas; flores artificiais; enfeites de cabelo; cabelos postiços.', collapsed: false},
            {classe: 'Classe 27', titulo: 'Classe 27', descricao: 'Carpetes, tapetes, capachos e esteiras, linóleo e outros revestimentos de assoalhos; colgaduras que não sejam em matérias têxteis.', collapsed: false},
            {classe: 'Classe 28', titulo: 'Classe 28', descricao: 'Jogos, joguetes e brinquedos; aparelhos de videogame; artigos para ginástica e esporte; decorações para árvores de Natal.', collapsed: false},
            {classe: 'Classe 29', titulo: 'Classe 29', descricao: 'Carne, peixe, aves e caça; extratos de carne; frutas, legumes e verduras em conserva, congelados, secos e cozidos; geleias, gelatinas e compotas; ovos; leite e laticínios; óleos e gorduras comestíveis.', collapsed: false},
            {classe: 'Classe 30', titulo: 'Classe 30', descricao: 'Café, chá, cacau, sucedâneos de café; arroz, tapioca e sagu; farinhas e preparações feitas de cereais; pão, massas e confeitos; gelados comestíveis; açúcar, mel, xarope de melaço; lêvedo, fermento em pó; sal; mostarda; vinagre, molhos (condimentos); especiarias; gelo.', collapsed: false},
            {classe: 'Classe 31', titulo: 'Classe 31', descricao: 'Produtos agrícolas, hortícolas, florestais e de aquacultura crus, não processados; grãos e sementes crus e não processados; frutas, legumes, ervas e verduras frescos; plantas e flores naturais; bulbos, mudas e sementes para plantio; animais vivos; alimentos e bebidas para animais; malte.', collapsed: false},
            {classe: 'Classe 32', titulo: 'Classe 32', descricao: 'Cervejas; águas minerais e gasosas e outras bebidas não alcoólicas; bebidas de frutas e sucos de fruta; xaropes e outras preparações para fazer bebidas.', collapsed: false},
            {classe: 'Classe 33', titulo: 'Classe 33', descricao: 'Bebidas alcoólicas (exceto cervejas).', collapsed: false},
            {classe: 'Classe 34', titulo: 'Classe 34', descricao: 'Tabaco; artigos para fumantes; fósforos.', collapsed: false}
          ],
          servico: [
            {classe: 'Classe 35', titulo: 'Classe 35', descricao: 'Propaganda; gestão de negócios; administração de negócios; funções de escritório.', collapsed: false},
            {classe: 'Classe 36', titulo: 'Classe 36', descricao: 'Seguros; negócios financeiros; negócios monetários; negócios imobiliários.', collapsed: false},
            {classe: 'Classe 37', titulo: 'Classe 37', descricao: 'Construção civil; reparos; serviços de instalação.', collapsed: false},
            {classe: 'Classe 38', titulo: 'Classe 38', descricao: 'Telecomunicações.', collapsed: false},
            {classe: 'Classe 39', titulo: 'Classe 39', descricao: 'Transporte; embalagem e armazenagem de produtos; organização de viagens.', collapsed: false},
            {classe: 'Classe 40', titulo: 'Classe 40', descricao: 'Tratamento de materiais.', collapsed: false},
            {classe: 'Classe 41', titulo: 'Classe 41', descricao: 'Educação, provimento de treinamento; entretenimento; atividades desportivas e culturais.', collapsed: false},
            {classe: 'Classe 42', titulo: 'Classe 42', descricao: 'Serviços científicos e tecnológicos, pesquisa e desenho relacionado a estes; serviços de análise industrial e pesquisa; concepção, projeto e desenvolvimento de hardware e software de computador.', collapsed: false},
            {classe: 'Classe 43', titulo: 'Classe 43', descricao: 'Serviços de fornecimento de comida e bebida; acomodações temporárias.', collapsed: false},
            {classe: 'Classe 44', titulo: 'Classe 44', descricao: 'Serviços médicos; serviços veterinários; serviços de higiene e beleza para seres humanos ou animais; serviços de agricultura, de horticultura e de silvicultura.', collapsed: false},
            {classe: 'Classe 45', titulo: 'Classe 45', descricao: 'Serviços jurídicos; serviços de segurança para proteção física de bens tangíveis e de pessoas; serviços pessoais e sociais prestados por terceiros para satisfazer necessidades de indivíduos.', collapsed: false}
          ]
        },
        registro: {
          step1: {
            id: 15,
            toddy: false,
            input: false,
            resposta: null
          },
          step2: {
            id: 16,
            toddy: false,
            input: false
          },
          step3: {
            id: 17,
            toddy: false,
            input: false,
            fields: false
          },
          step4: {
            id: 18,
            toddy: false,
            input: false,
            resposta: null,
            fields: false,
            uf: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO']
          }
        },
        procedimento: {
          step1: {
            id: 19,
            toddy: false,
            input: false,
            fields: false
          },
          step2: {
            id: 20,
            toddy: false,
            input: false
          },
          step3: {
            id: 21,
            toddy: false,
            input: false,
            fields: false
          }
        },
        termosDeUso: {
          id: 22,
          toddy: false,
          input: false,
          resposta: null
        },
        cobranca: {
          id: 23,
          toddy: false,
          input: false,
          fields: false,
          resposta: null
        },
        boleto: {
          id: 24,
          toddy: false,
          input: false,
          resposta: null
        },
        deposito: {
          id: 25,
          toddy: false,
          input: false,
          resposta: null
        },
        pagamentoRealizado: {
          id: 26,
          toddy: false,
          input: false,
          resposta: null
        },
        procuracao: {
          id: 27,
          toddy: false,
          input: false,
          resposta: null
        },
        error: {
          id: 28,
          toddy: false,
          input: false,
          resposta: null
        },
        fim: {
          step1: {
            id: 29,
            toddy: false,
            input: false,
            resposta: null
          },
          step2: {
            id: 30,
            toddy: false,
            input: false,
            fields: false
          }
        }
      },
      prices: {
        txPesquisa: null,
        txINPIPFPJMEEPP: null,
        txINPIPJ: null,
        txServicos: null
      },
      form: {
        nome: null,
        marca: null,
        tipo_de_empresa: null,
        classes: [],
        pessoa_fisica: null,
        meepp: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        estado: null,
        termos_de_uso: null,
        boleto_bancario: null,
        nome_completo: null,
        cpf: null,
        cnpj: null,
        email: null,
        telefone: null,
        txPesquisa: null,
        txINPI: null,
        txServicos: null,
        total: null
        // cartao_titular: null,
        // cartao_numero: null,
        // cartao_cvv: null,
        // cartao_validade: null
        // nome: 'Leonardo',
        // marca: 'Mocka',
        // tipo_de_empresa: 'Serviço',
        // classes: ['Classe 1', 'Classe 2'],
        // pessoa_fisica: false,
        // meepp: false,
        // cep: '91750-111',
        // endereco: 'Rua Rio Grande',
        // numero: '166',
        // complemento: 'Frente',
        // bairro: 'Aberta dos Morros',
        // cidade: 'Porto Alegre',
        // estado: null,
        // termos_de_uso: false,
        // boleto_bancario: false,
        // nome_completo: 'Leonardo Bonfim Silva Reis',
        // cpf: '115.776.047-33',
        // cnpj: '10.456.461/0001-27',
        // email: 'leonardobsr@gmail.com',
        // telefone: '(51) 98506-9146',
        // txPesquisa: null,
        // txINPI: null,
        // txServicos: null,
        // total: null
        // cartao_titular: 'Leonardo Reis',
        // cartao_numero: '5454545454545',
        // cartao_cvv: '123',
        // cartao_validade: '06/20'
      },
      imageFile: null,
      imageProcuracao: null
    }
  },
  components: {
    'vue-typed-js': VueTypedJs
  },
  computed: {
    isInitial () {
      return this.chatbot.logo.currentStatus === STATUS_INITIAL
    },
    isSaving () {
      return this.chatbot.logo.currentStatus === STATUS_SAVING
    },
    isSuccess () {
      return this.chatbot.logo.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.chatbot.logo.currentStatus === STATUS_FAILED
    }
  },
  methods: {
    isStarting: function () {
      let uri = BASE_URL + 'config/'
      axios.get(uri)
        .then((response) => {
          this.prices.txPesquisa = response.data.params.txPesquisa
          this.prices.txINPIPFPJMEEPP = response.data.params.txINPIPFPJMEEPP
          this.prices.txINPIPJ = response.data.params.txINPIPJ
          this.prices.txServicos = response.data.params.txServicos
          setTimeout(() => {
            this.isClosing = true
            setTimeout(() => {
              this.isDone = true
              this.steps.push(this.chatbot.inicio)
            }, 2000)
          }, 2000)
        })
    },
    showBoxInput: function (boolean) {
      if (boolean) {
        this.boxInput = boolean
        setTimeout(() => {
          var container = this.$el.querySelector('#terminal-input')
          this.boxInputHeight = (container.offsetHeight + 32)
        }, 0)
      } else {
        this.boxInputHeight = 64
        this.boxInput = boolean
      }
    },
    showFields: function (place) {
      place.fields = true
      this.showBoxInput(true)
    },
    previousStep: function () {
      for (let index = this.steps.length - 1; index >= 0; index--) {
        if (this.steps[index] !== this.previousNodo) {
          this.steps[index].toddy = false
          this.steps[index].input = false
          if (this.steps[index].resposta) this.steps[index].resposta = null
          if (this.steps[index].fields) this.steps[index].fields = false
          this.steps.splice(index, 1)
          if (this.previousNodo.resposta) this.previousNodo.resposta = null
          this.previousNodo.input = true
          this.showBoxInput(true)
        } else {
          this.previousNodo = this.steps[index - 1]
          break
        }
      }
    },
    nextStep: function (previous, current, next) {
      this.showBoxInput(false)
      setTimeout(() => {
        this.previousNodo = previous
        current.input = false
        next.toddy = true
        next.input = true
        this.steps.push(next)
      }, 1000)
    },
    scrollTop: function () {
      var container = this.$el.querySelector('#terminal-chat')
      container.scrollTop = container.scrollHeight
    },
    seeMore: function (element) {
      (element.collapsed) ? element.collapsed = false : element.collapsed = true
    },
    loader: function (time) {
      let vm = this
      return new Promise(resolve => {
        let intervalId = setInterval(tick, time / 100)
        function tick () {
          vm.chatbot.logo.uploadPercentage = (Math.round(vm.chatbot.logo.uploadPercentage * 100) / 100) + 1
          if (vm.chatbot.logo.uploadPercentage === 100) {
            clearInterval(intervalId)
            resolve(1)
          }
        }
      })
    },
    filesChange: function (fieldName, fileList) {
      const formData = new FormData()
      if (!fileList.length) return
      Array
        .from(Array(fileList.length).keys())
        .map(x => { formData.append(fieldName, fileList[x], fileList[x].name) })
      this.save(formData)
    },
    save: function (formData) {
      this.chatbot.logo.currentStatus = STATUS_SAVING
      this.imageFile = formData
      setTimeout(() => {
        this.loader(3000)
          .then(() => {
            this.preview(formData)
              .then(success => {
                this.chatbot.logo.uploadedFiles = [].concat(success)
                this.chatbot.logo.currentStatus = STATUS_SUCCESS
              },
              error => {
                this.chatbot.logo.uploadError = error.message
                this.chatbot.logo.currentStatus = STATUS_FAILED
              })
          })
      }, 0)
    },
    preview: function (formData) {
      let photos = formData.getAll('photos')
      let promises = photos.map((x) => this.getImage(x)
        .then(img => ({
          id: img.src,
          originalName: x.name,
          fileName: x.name,
          width: img.width,
          height: img.height,
          size: x.size,
          url: img.src
        })))
      return Promise.all(promises)
    },
    getImage: function (file) {
      if (file.type !== 'image/jpg' && file.type !== 'image/jpeg') {
        return Promise.reject(new Error('Tipo de arquivo inválido'))
      }
      return new Promise((resolve, reject) => {
        const fReader = new FileReader()
        const img = document.createElement('img')

        fReader.onload = () => {
          img.src = fReader.result
          resolve(this.getBase64Image(img))
        }

        fReader.readAsDataURL(file)
      })
    },
    getBase64Image: function (img) {
      if (img.width > 300 || img.height > 300) {
        return Promise.reject(new Error('Tamanho do arquivo inválido'))
      }
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height

      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      const dataURL = img
      return dataURL
    },
    resetUpload: function () {
      this.chatbot.logo.currentStatus = STATUS_INITIAL
      this.chatbot.logo.uploadedFiles = []
      this.chatbot.logo.uploadError = null
      this.chatbot.logo.uploadPercentage = 0
    },
    submitRegistroStep3: function (evt) {
      evt.preventDefault()
      if (!this.$refs.registroStep3.checkValidity()) {
        this.$refs.registroStep3.reportValidity()
        return
      }
      this.registroStep3()
    },
    submitRegistroStep4: function (evt) {
      evt.preventDefault()
      if (!this.$refs.registroStep4.checkValidity()) {
        this.$refs.registroStep4.reportValidity()
        return
      }
      this.registroStep4()
    },
    uploadSalvarRegistro: function () {
      let vm = this
      const photos = vm.imageFile.getAll('photos')
      let uri = BASE_URL + 'files/' + 'logo-' + photos[0].name
      return new Promise(function (resolve, reject) {
        axios.post(
          uri,
          photos[0],
          {
            headers: {
              'Content-Type': photos[0].type
            }
          })
          .then(function (response) {
            vm.form.logo = JSON.parse(JSON.stringify({'__type': 'File', 'name': response.data.name, 'url': response.data.url}))
            resolve(vm.novoRegistro())
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    novoRegistro: function () {
      let vm = this
      let uri = BASE_URL + 'classes/Registro'
      return new Promise(function (resolve, reject) {
        axios.post(uri, vm.form)
          .then(function (response) {
            vm.id_chamada = response.data.objectId
            resolve(true)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    lowerCase: function (str) {
      return str.toLowerCase()
    },
    upperCase: function (str) {
      return str.toUpperCase()
    },
    properCase: function (str) {
      return this.lowerCase(str).replace(/^\w|\s\w/g, this.upperCase)
    },
    pdf: function () {
      let vm = this
      return new Promise(function (resolve, reject) {
        let monthNames = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
        let today = new Date()
        let textPF = [
          {text: vm.properCase(vm.form.nome_completo) + ',', bold: true},
          ' (CPF nº. ' + vm.form.cpf + ', com residência e domicilio na ' + vm.properCase(vm.form.endereco) + ', ' + vm.form.numero + ' - ' + vm.form.complemento + ' - ' + vm.properCase(vm.form.bairro) + ' - ' + vm.properCase(vm.form.cidade) + ' - ' + vm.form.estado + ' - ' + vm.form.cep + ';\n\n\n\n'
        ]
        let textPJ = [
          {text: vm.properCase(vm.form.nome_completo) + ',', bold: true},
          ' inscrito no CNPJ sob nº. ' + vm.form.cnpj + ', com sede na ' + vm.properCase(vm.form.endereco) + ', ' + vm.form.numero + ' - ' + vm.form.complemento + ' - ' + vm.properCase(vm.form.bairro) + ' - ' + vm.properCase(vm.form.cidade) + ' - ' + vm.form.estado + ' - ' + vm.form.cep + ', neste ato representada conforme seu contrato social;\n\n\n\n'
        ]
        var docProcuracao = {
          content: [
            {
              text: 'INSTRUMENTO PARTICULAR DE PROCURAÇÃO\n\n\n\n',
              style: 'header'
            },
            {
              text: 'OUTORGANTE:',
              style: 'subheader'
            },
            {
              text: (vm.form.pessoa_fisica) ? textPF : textPJ,
              style: 'justify'
            },
            {
              text: 'OUTORGADOS:',
              style: 'subheader'
            },
            {
              text: [
                {text: 'LAYON LOPES DA SILVA', bold: true},
                ' (CPF/MF 006.267.920-10 - OAB/RS 83.891), brasileiro, solteiro, advogado, com endereço profissional na Avenida Ipiranga, n°. 40, sala 1005, bairro Praia de Belas, em Porto Alegre/RS, CEP. 90160-090.\n\n\n\n'
              ],
              style: 'justify'
            },
            {
              text: 'PODERES:\n\n\n\n',
              style: 'subheader'
            },
            {
              text: [
                'A Outorgante nomeia e constitui seu bastante procurador o Outorgado, para o fim especial de defender os interesses da Outorgante perante ',
                {text: 'o Instituto Nacional da Propriedade Industrial, com o fim de requerer e processar pedidos de registro de marcas, indicações geográficas, patentes de invenção, modelos de utilidade, registros de desenhos industriais, registros de programas de computador, pedidos de extensão de proteção ao nome comercial, e outros relativos à propriedade industrial, como anotações, firmas e denominações sociais, licença de uso e exploração de marcas, patentes e desenhos industriais, bem como de contratos de transferência de tecnologia, assistência técnica e “know-how”, registros e outros atos relacionados a nomes de domínio', fontSize: 11, bold: true, decoration: 'underline'},
                ', para o que lhe concede todos os poderes contidos nas cláusulas “ad judicia et extra”, e mais os especiais de acordar, discordar, transigir, firmar compromissos, desistir, receber, dar e receber quitação, levantar e receber alvarás, recorrer perante quaisquer instâncias ou tribunais, substabelecer a presente, com ou sem reservas, podendo, enfim, praticar todo e qualquer ato necessário ao bom e fiel desempenho do presente mandado.\n\n\n\n'
              ],
              style: 'justify'
            },
            {
              text: [
                'Porto Alegre, RS, ' + today.getDate() + ' de ' + monthNames[today.getMonth()] + ' de ' + today.getUTCFullYear() + '.\n\n\n\n\n\n',
                '_________________________________________________\n',
                {text: vm.properCase(vm.form.nome_completo) + '\n', bold: true}
              ],
              style: 'center'
            }
          ],
          styles: {
            fontsize: {
              fontsize: 11
            },
            header: {
              bold: true,
              alignment: 'center'
            },
            subheader: {
              bold: true
            },
            justify: {
              alignment: 'justify'
            },
            center: {
              alignment: 'center'
            }
          }
        }
        const pdfComplete = pdfMake.createPdf(docProcuracao)
        pdfComplete.getBuffer(function (buffer) {
          let uri = BASE_URL + 'files/procuracao' + vm.form.nome + '.pdf'
          axios.post(
            uri,
            buffer,
            {
              headers: {
                'Content-Type': 'application/pdf'
              }
            })
            .then(function (response) {
              vm.form.procuracao = JSON.parse(JSON.stringify({'__type': 'File', 'name': response.data.name, 'url': response.data.url}))
              resolve(vm.uploadSalvarRegistro()
                .then(function (response) {
                  pdfComplete.download('procuracao.pdf')
                }))
            })
            .catch(function (error) {
              resolve(error)
            })
        })
      })
    },
    monitorHeight () {
      // Create a new mutation observer
      this.heightMonitor = new MutationObserver(this.checkHeight)
      // Start observing $el for an attribute, childlist, or subtree changes
      this.heightMonitor.observe(this.$el, {
        attributes: true,
        childList: true,
        subtree: true
      })
    },
    checkHeight () {
      var container = document.getElementById('terminal-chat')
      if (container === null || container === undefined) return true
      if (container.scrollHeight !== this.height && (container.scrollHeight - this.height) > 30) {
        container.scrollTop = container.scrollHeight
        this.height = container.scrollHeight
      }
    },
    inicio: function (event, boolean) {
      this.stepBack = true
      this.chatbot.inicio.resposta = event.target.innerText
      if (boolean) {
        this.nextStep(this.chatbot.inicio, this.chatbot.inicio, this.chatbot.nome)
      } else {
        this.nextStep(this.chatbot.inicio, this.chatbot.inicio, this.chatbot.protocolo.step1)
      }
    },
    protocolo: function (event, boolean) {
      event.preventDefault()
      this.chatbot.protocolo.step1.error = false
      let uri = BASE_URL + 'classes/Registro/'
      axios.get(uri + this.id_chamada)
        .then((response) => {
          console.log(response, response.data.protocolo)
          if (response.data.protocolo !== undefined) {
            this.arquivo_protocolo = response.data.protocolo.url
            this.nextStep(this.chatbot.protocolo.step1, this.chatbot.protocolo.step1, this.chatbot.protocolo.step2)
          } else {
            this.nextStep(this.chatbot.protocolo.step1, this.chatbot.protocolo.step1, this.chatbot.protocolo.step3)
          }
        })
        .catch(error => {
          if (error.request.status === 404) this.chatbot.protocolo.step1.error = true
        })
    },
    protocoloStep2: function () {
      this.chatbot.protocolo.step2.input = false
      this.nextStep(this.chatbot.protocolo.step2, this.chatbot.protocolo.step2, this.chatbot.protocolo.step4)
      this.showBoxInput(true)
    },
    protocoloStep3: function () {
      this.showBoxInput(true)
      this.chatbot.fim.step2.input = true
      this.nextStep(this.chatbot.protocolo.step2, this.chatbot.protocolo.step2, this.chatbot.protocolo.step4)
    },
    nome: function (event) {
      event.preventDefault()
      this.letterIcon = this.form.nome.toString().charAt(0)
      this.chatbot.nome.resposta = true
      this.nextStep(this.chatbot.nome, this.chatbot.nome, this.chatbot.processo)
    },
    processo: function (event, boolean) {
      this.chatbot.processo.resposta = event.target.innerText
      if (boolean) {
        this.nextStep(this.chatbot.processo, this.chatbot.processo, this.chatbot.marca)
      } else {
        this.nextStep(this.chatbot.processo, this.chatbot.processo, this.chatbot.textoExplicativo.step1)
      }
    },
    marca: function (event) {
      event.preventDefault()
      this.chatbot.marca.resposta = true
      this.resetUpload()
      this.nextStep(this.chatbot.marca, this.chatbot.marca, this.chatbot.logo)
    },
    logo: function () {
      this.chatbot.logo.resposta = true
      this.nextStep(this.chatbot.logo, this.chatbot.logo, this.chatbot.funcao)
    },
    funcao: function (event) {
      this.form.tipo_de_empresa = event.target.innerText
      this.chatbot.funcao.resposta = event.target.innerText
      this.nextStep(this.chatbot.funcao, this.chatbot.funcao, this.chatbot.classes)
    },
    classes: function () {
      this.chatbot.classes.fields = false
      this.chatbot.classes.resposta = true
      this.nextStep(this.chatbot.classes, this.chatbot.classes, this.chatbot.registro.step1)
    },
    registroStep1: function (n) {
      this.form.pessoa_fisica = n
      if (n) {
        this.chatbot.registro.step1.resposta = 'Pessoa Física'
        this.nextStep(this.chatbot.registro.step1, this.chatbot.registro.step1, this.chatbot.registro.step3)
      } else {
        this.chatbot.registro.step1.resposta = 'Pessoa Júridica'
        this.nextStep(this.chatbot.registro.step1, this.chatbot.registro.step1, this.chatbot.registro.step2)
      }
    },
    registroStep2: function (n) {
      this.form.meepp = n
      this.chatbot.registro.step2.resposta = n ? 'Sim' : 'Não'
      this.nextStep(this.chatbot.registro.step2, this.chatbot.registro.step2, this.chatbot.registro.step3)
    },
    registroStep3: function () {
      this.chatbot.registro.step3.resposta = true
      this.nextStep(this.chatbot.registro.step3, this.chatbot.registro.step3, this.chatbot.registro.step4)
    },
    registroStep4: function () {
      this.chatbot.registro.step4.resposta = true
      this.nextStep(this.chatbot.registro.step4, this.chatbot.registro.step4, this.chatbot.procedimento.step1)
    },
    procedimentoStep1: function () {
      let tempINPI = (this.form.pessoa_fisica || this.form.meepp) ? this.prices.txINPIPFPJMEEPP : this.prices.txINPIPJ

      this.form.txPesquisa = this.$options.filters.currency(this.prices.txPesquisa)
      this.form.txINPI = this.$options.filters.currency(tempINPI)
      this.form.txServicos = this.$options.filters.currency((this.prices.txServicos * this.form.classes.length))

      this.form.total = this.$options.filters.currency(this.prices.txPesquisa + tempINPI + (this.prices.txServicos * this.form.classes.length))

      this.nextStep(this.chatbot.procedimento.step1, this.chatbot.procedimento.step1, this.chatbot.procedimento.step2)
    },
    procedimentoStep3: function () {
      this.nextStep(this.chatbot.procedimento.step3, this.chatbot.procedimento.step3, this.chatbot.termosDeUso)
    },
    termosDeUso: function () {
      this.form.termos_de_uso = true
      this.chatbot.termosDeUso.resposta = true
      this.nextStep(this.chatbot.termosDeUso, this.chatbot.termosDeUso, this.chatbot.cobranca)
    },
    cobranca: function (event, n) {
      this.form.boleto_bancario = n
      this.chatbot.cobranca.resposta = event.target.innerText
      if (n) {
        this.nextStep(this.chatbot.cobranca, this.chatbot.cobranca, this.chatbot.boleto)
      } else {
        this.nextStep(this.chatbot.cobranca, this.chatbot.cobranca, this.chatbot.deposito)
      }
    },
    deposito: function () {
      this.chatbot.deposito.resposta = true
      this.nextStep(this.chatbot.deposito, this.chatbot.deposito, this.chatbot.procuracao)
    },
    pagamentoRealizado: function () {
      this.chatbot.pagamentoRealizado.resposta = true
      this.nextStep(this.chatbot.pagamentoRealizado, this.chatbot.pagamentoRealizado, this.chatbot.procuracao)
    },
    procuracao: function () {
      let vm = this
      vm.pdf()
        .then(function (response) {
          if (vm.id_chamada !== false && vm.id_chamada !== null && vm.id_chamada !== undefined) {
            vm.nextStep(vm.chatbot.procuracao, vm.chatbot.procuracao, vm.chatbot.fim.step1)
          } else {
            vm.nextStep(vm.chatbot.procuracao, vm.chatbot.procuracao, vm.chatbot.error)
            vm.showBoxInput(true)
          }
          vm.stepBack = false
        })
    },
    fim: function () {
      this.showBoxInput(false)
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    },
    mask,
    autobottom: {
      inserted: function () {
        var container = document.getElementById('terminal-chat')
        container.scrollTop = container.scrollHeight * 2
      },
      update: function () {
        var container = document.getElementById('terminal-chat')
        container.scrollTop = container.scrollHeight * 2
      }
    }
  },
  filters: {
    Filesize: function (size) {
      if (isNaN(size)) size = 0

      if (size < 1024) return size + ' Bytes'

      size /= 1024

      if (size < 1024) return size.toFixed(2) + ' Kb'

      size /= 1024

      if (size < 1024) return size.toFixed(2) + ' Mb'

      size /= 1024

      if (size < 1024) return size.toFixed(2) + ' Gb'

      size /= 1024

      return size.toFixed(2) + ' Tb'
    }
  },
  mounted () {
    document.body.style.minHeight = window.innerHeight + 'px'
    document.body.style.maxHeight = window.innerHeight + 'px'
    this.isStarting()
    this.resetUpload()
    this.$nextTick(() => {
      // Create the height monitor
      this.monitorHeight()
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Toddy.vue